import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
    Col,
    Table,
    Card,
    CardBody,
    Modal,
    ModalBody,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    Button,
    Dropdown,
    DropdownToggle,
    DropdownMenu
} from "reactstrap"
import { SuccessOk } from "configs/statusCode"
import { adminPrefix } from "configs/routePrefix"
import Paginator from "components/Common/Paginator/Paginator"
import MasterPlanServices from "services/Admin/MasterPlanServices"
import SelectOptions from "components/SelectOptions"
import BuildingService from "services/Admin/BuildingService"
import CompoundService from "services/Admin/CompoundService"
import ImageMapper from "react-image-mapper";
import { toast } from "react-toastify"
import Select from "react-select";

const MasterPlan = () => {
    const [formData, setFormData] = useState({
        selectedBulding: null,
        selectedCompound: null

    })
    const [key, setKey] = useState(0)
    const [buildingOpttions, setBuildingOpttions] = useState([])
    const [CompoundOpttions, setCompoundpttions] = useState([])
    const [mapAreas, setMapAreas] = useState({
        name: "my-map",
        areas: [
            // { id: 5, shape: "circle", coords: [170, 100, 10], preFillColor: "#fff" }
        ],
    });

    const handleUpdateMapArea = (evt) => {
        updateMapArea(evt.nativeEvent.layerX, [
            evt.nativeEvent.layerX,
            evt.nativeEvent.layerY,
            10
        ]);
    };

    const getTipPosition = (area) => {
        // const obj = { top: `${area.center[1]}px`, left: `${area.center[0]}px` };
        const selectedItem = mapAreas.areas.find(item => item.id === area.id)

        setMapAreas(mapAreas => ({
            ...mapAreas,
            areas: mapAreas.areas.filter((item) => item.id !== area.id)
        }));
        setBuildingOpttions([...buildingOpttions, selectedItem.selectedBulding])
        setKey(key + 1)
    };

    const updateMapArea = (id, coords) => {
        if (formData.selectedBulding) {
            const a = {
                id: id, shape: "circle", coords: coords, preFillColor: "red", selectedBulding: formData.selectedBulding
            };
            mapAreas.areas.push(a);
            setMapAreas({
                name: mapAreas.name,
                areas: mapAreas.areas,
            });

            setBuildingOpttions(buildingOpttions => {
                return buildingOpttions.filter(option => option ?.value != formData.selectedBulding ?.value)
            })
            setFormData({
                ...formData,
                selectedBulding: null
            })
        } else {
            toast.error("Please Select the compound and building first")
        }

    };
    const buildingService = new BuildingService()
    useEffect(() => {
        setMapAreas({
            name: "my-map",
            areas: []
        })
        if (formData ?.selectedCompound ?.value) {
            buildingService.getDropDown(formData ?.selectedCompound ?.value).then(res => {
                const newOptions = res.data.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setBuildingOpttions(newOptions)
            })
        } else {
            setBuildingOpttions([])
        }

    }, [formData.selectedCompound])

    return (
        <React.Fragment>
            <div className='page-content'>
                <MetaTags>
                    <title>Master Plan</title>
                </MetaTags>
                <Container fluid>
                    <Row className="mb-1">
                        <Col md={6}>
                            <h4>Master Plan</h4>
                            <p>Quick Figures</p>
                        </Col>
                    </Row>
                    <Row className="mt-4" style={{ zIndex: -1 }}>
                        <ImageMapper
                            key={key}
                            src={`https://c1.staticflickr.com/5/4052/4503898393_303cfbc9fd_b.jpg`}
                            onClick={(area) => getTipPosition(area)}
                            onImageClick={handleUpdateMapArea}
                            map={mapAreas}
                            width={500}
                        />
                    </Row>
                    <Row className="my-2">

                        <Col md={6}>
                            <SelectOptions
                                label='Compound '
                                placeholder='Select'
                                options={CompoundOpttions}
                                handleSelectChange={(data) => {
                                    setFormData({ ...formData, selectedCompound: data });
                                }}
                                selectedOption={formData.selectedCompound}
                                Service={CompoundService}
                                setOptions={(options) => {
                                    setCompoundpttions(options)
                                }}
                            />
                        </Col>
                        <Col md={6}>


                            <label>Building</label>
                            <Select
                                placeholder='Select'
                                options={buildingOpttions}
                                className='mb-3 '
                                onChange={(data) => {
                                    setFormData({ ...formData, selectedBulding: data });
                                }}
                                value={formData.selectedBulding}
                                setOptions={(options) => {
                                    setBuildingOpttions(options)
                                }}
                            />
                        </Col>
                    </Row>
                   

                    <Row className="mt-4">
                        <Button onClick={() => { }}>submit</Button>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}
export default MasterPlan